import * as Sentry from '@sentry/vue';

const handleError = function (error) {
  if (error instanceof Error) {
    // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
    setTimeout(() => {
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureMessage(error);
  }
};

export const setSentryUser = (clientId) => {
  Sentry.setUser({
    id: clientId,
  });
};

export class Logger {
  static fatal = function (error, tags = {}) {
    console.error(error);

    try {
      Sentry.withScope(function (scope) {
        for (const [key, value] of Object.entries(tags)) {
          scope.setTag(key, value);
        }
        scope.setLevel('fatal');

        handleError(error);
      });
    } catch (err) {
      console.error(err);
    }
  };

  static error = function (error, tags = {}) {
    console.error(error);

    try {
      Sentry.withScope(function (scope) {
        for (const [key, value] of Object.entries(tags)) {
          scope.setTag(key, value);
        }
        scope.setLevel('error');

        handleError(error);
      });
    } catch (err) {
      console.error(err);
    }
  };

  static warn = function (error, tags = []) {
    console.log(error);

    try {
      Sentry.withScope(function (scope) {
        for (const [key, value] of Object.entries(tags)) {
          scope.setTag(key, value);
        }
        scope.setLevel('warning');

        handleError(error);
      });
    } catch (err) {
      console.error(err);
    }
  };

  static info = function (error, tags = {}) {
    console.log(error);

    try {
      Sentry.withScope(function (scope) {
        for (const [key, value] of Object.entries(tags)) {
          scope.setTag(key, value);
        }
        scope.setLevel('info');

        handleError(error);
      });
    } catch (err) {
      console.error(err);
    }
  };

  static debug = function (error, tags = {}) {
    console.log(error);

    try {
      Sentry.withScope(function (scope) {
        for (const [key, value] of Object.entries(tags)) {
          scope.setTag(key, value);
        }
        scope.setLevel('debug');

        handleError(error);
      });
    } catch (err) {
      console.error(err);
    }
  };
}
